import React, { useEffect } from "react";
import { Layout } from "antd";
import ContentRoutes from "./ContentRoutes";
import Sidebar from "./sidebar/Sidebar";
import Header from "./Header";
import socketService from "../services/socketService";
import useFirebaseNotifications from "../hooks/useFirebaseNotifications";

const { Content } = Layout;

const App = () => {
  useFirebaseNotifications();

  useEffect(() => {
    socketService.connect();
  }, []);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1">
        <Header />
        <Content className="flex-1 bg-gray-50 overflow-y-auto">
          <ContentRoutes />
        </Content>
      </div>
    </div>
  );
};

export default App;
